import { LoadingOutlined, CheckCircleOutlined, EditOutlined, WarningOutlined } from '@ant-design/icons';
import type { AutosaveResult } from '../hooks/useAutosave';

function hhmm(ts: number): string {
  return new Date(ts).toLocaleTimeString('zh-TW', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Asia/Taipei',
  });
}

/** 手機 header 用的精簡版：只有短字、不帶時間與圖示，不換行。 */
function CompactStatus({ status }: { status: AutosaveResult['status'] }) {
  const label: Record<string, string> = {
    saving: '儲存中…',
    error: '儲存失敗',
    dirty: '未儲存',
    saved: '已儲存',
  };
  const color = status === 'error' ? 'text-[#d4380d]' : 'text-gray-500';
  return <span className={`shrink-0 text-xs ${color}`}>{label[status] ?? ''}</span>;
}

/** 自動儲存狀態列：儲存中… / 已自動儲存 HH:mm / 有未儲存變更 / 自動儲存失敗。 */
export default function SaveStatusText({ autosave, compact = false }: { autosave: AutosaveResult; compact?: boolean }) {
  const { status, savedAt } = autosave;
  if (compact) return <CompactStatus status={status} />;
  if (status === 'saving') {
    return (
      <span className="text-xs text-[#8a94a6]">
        <LoadingOutlined className="mr-1" />
        儲存中…
      </span>
    );
  }
  if (status === 'error') {
    return (
      <span className="text-xs text-[#d4380d]">
        <WarningOutlined className="mr-1" />
        自動儲存失敗，請按「立即儲存」重試
      </span>
    );
  }
  if (status === 'dirty') {
    return (
      <span className="text-xs text-[#dd7900]">
        <EditOutlined className="mr-1" />
        有未儲存變更…
      </span>
    );
  }
  if (status === 'saved' && savedAt) {
    return (
      <span className="text-xs text-[#389e0d]">
        <CheckCircleOutlined className="mr-1" />
        已自動儲存 {hhmm(savedAt)}
      </span>
    );
  }
  return <span className="text-xs text-[#8a94a6]">尚無變更</span>;
}
